module.exports = __webpack_public_path__ + "static/media/risk.f69b0da5.pdf";